import { configureStore } from "@reduxjs/toolkit";
import cartSilce from "./silces/cartSilces";
const store = configureStore({
    reducer:{
        cart:cartSilce,

    }
})

export default store;